import React, { useState } from 'react'
import Select from 'react-select'
import { Drawer, Tabs, Dropdown, Menu } from 'antd'
import { useHistory, useParams } from 'react-router-dom'

import { useToggle, usePet, useListData } from '../../modules'

import Receive from '../reusable/receive'
import Confirm from '../reusable/confirm'
import Modal from "../reusable/modal"
import Patient from '../reusable/patient'

import NewPatient from '../modals/newPatient'

const Procedure = ({ toggle, visible, patient, onPerform }) => {
    const [procedures, setProcedures] = useState([])
    const [procedure, setProcedure] = useState()

    const onComplete = ({}, notif, ops) => {
        notif('Patient has been admitted', ops('success'))
        setTimeout(toggle, 300)
        onPerform()
    }

    const [{ loading, error }] = usePet('singleSaleItem', { name: 'Theatre Operations' }, { notify: true, callback: ({ data }) => setProcedures(data?.variants) })

    const [{ loading: rLoading }, recordProcedure] = usePet('billPatient', {
        patient: patient?._id,
        items: [
            {
                item: procedure?.value,
                quantity: 1,
                price: 0
            }
        ],
        station: localStorage.getItem('station') ?? 'Theatre',
        inPatient: true
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Creating record...' } })

    return (
        <Modal
            w={ 400 }
            title="Create Record"
            toggle={toggle}
            visible={visible}>
            <div className="w-full my-3">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                    Select Procedure
                </label>
                <Select
                    value={procedure}
                    onChange={setProcedure}
                    styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                    options={ procedures?.map(item => ({ label: item.name, value: item._id, ...item })) }
                    placeholder="Select Procedure" />
            </div>
            <div className="flex justify-end">
                <button disabled={ rLoading } onClick={ () => Confirm({
                    title: 'Create record?',
                    message: 'Please confirm before performing this action',
                    okText: 'Create record',
                    onOk: recordProcedure
                }) } type="submit" className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Proceed</button>
            </div>
        </Modal>
    )
}

const RecordTheatre = ({ onCreate }) => {
    const [string, setString] = useState('')
    const [pt, setPatient] = useState()

    const history = useHistory()

    const [visible, toggleVisible] = useToggle(true)
    const [details, toggleDetails] = useToggle()
    const [newpatient, toggleNewPatient] = useToggle()

    const [
        { loading: pLoading, error: pError, fetch: fetchAdmissions },
        { list: admissions },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('admissions', { string, type: 'All', order: -1 }, { notify: true })

    const refresh = () => {
        navigate(1)
        fetchAdmissions()
    }

    const search = str => {
        setString(str)
        refresh()
    }

    const close = () => {
        toggleVisible()
        setTimeout(() => history.goBack(), 300)
    }

    const newRecord = ptn => {
        setPatient(ptn)
        toggleDetails()
    }

    const onPerform = data => {
        onCreate(data)
        close()
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            // footer={
            //     <div className="w-full text-right">
            //         <button className="text-white mr-2 hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Admit Patient</button>                    
            //         <button className="text-white mr-2 hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
            //     </div>
            // }
            width="40%">
            {
                details &&
                <Procedure
                    toggle={ toggleDetails }
                    patient={ pt }
                    visible={ details }
                    onPerform={ onPerform }/>
            }
            <p className="font-extrabold text-3xl mb-0">New Theatre Record</p>
            <div className="mt-3">
                <div className="sm:flex sm:justify-between sm:items-center mb-4">
                    <input
                        onChange={e => search(e.target.value)}
                        className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                        id="grid-search"
                        type="text"
                        placeholder="Patient Name, OP/IP No." />
                    <button onClick={ toggleNewPatient } className="btn ml-2 py-2.1 hisani-btn-green-light text-white">New Patient</button>
                </div>
                <NewPatient
                    onPerform={ refresh }
                    toggle={ toggleNewPatient }
                    visible={ newpatient }/>
                <Receive
                    progress
                    loading={pLoading}
                    error={pError}>
                    {
                        admissions?.length > 0 ?
                            <div className="overflow-x-auto">
                                <table className="table-auto w-full">
                                    {/* Table header */}
                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                        <tr>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">No</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Patient Name</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-center"></div>
                                            </th>
                                        </tr>
                                    </thead>
                                    {/* Table body */}
                                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                                        {
                                            admissions.map((item, key) =>
                                                <tr>
                                                    <td className="p-2">
                                                        <div className="text-center">
                                                            { ((page - 1) * limit) + (key + 1)}.
                                                        </div>
                                                    </td>
                                                    <td className="p-2">
                                                      <Patient patient={ item.patient } />
                                                    </td>
                                                    <td className="p-2">
                                                        <button onClick={ () => newRecord(item.patient) } className="btn ml-2 py-1 hisani-btn-green-light text-white">Record Patient</button>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            :
                            <div className="w-full h-16 flex items-center justify-center">
                                <p className="font-semibold text-base">You can add a new patient by clicking above</p>
                            </div>
                    }
                </Receive>
                {Paginate}
            </div>
        </Drawer>
    )
}

export default RecordTheatre